<form [formGroup]="newSiteForm">
  <div class="form-step-container">
    <div class="form-step-title">HOW WOULD YOU LIKE TO DEFINE YOUR SITE?</div>

    <mat-radio-group formControlName="locationType">
      <mat-radio-button (change)="radioChange($event)" checked="true" id="inputRadio" value="geoLocate">
        Create My Own Custom Map
        <fa-icon
          #tooltip1="matTooltip"
          (click)="tooltip1.toggle()"
          [icon]="['far', 'circle-info']"
          class="blue"
          matTooltip="Use stand definitions and drawing tools to define what's included in your carbon offset site."
          matTooltipClass="fc-tooltip"
          matTooltipPosition="right"></fa-icon>
      </mat-radio-button>

      <mat-radio-button (change)="radioChange($event)" id="uploadRadio" value="kml">
        Upload a .kml or .kmz File
        <fa-icon
          #tooltip2="matTooltip"
          (click)="tooltip2.toggle()"
          [icon]="['far', 'circle-info']"
          class="blue"
          matTooltip="Use a .kml or .kmz file created elsewhere to define what's included in your carbon offset site. After you upload your file, use our drawing tools to edit the included areas."
          matTooltipClass="fc-tooltip"
          matTooltipPosition="right"></fa-icon>
      </mat-radio-button>

      <ng-container *ngIf="kmlUpload">
        <div class="kml-upload-button-container">
          <ng-container>
            <button
              (click)="onClickKmlUpload()"
              class="button"
              data-cy="kml-upload-button"
              color="primary"
              mat-raised-button
              type="button">
              {{ uploadKmlFileName ? 'Re-' : '' }}Upload
            </button>
          </ng-container>
          <ng-container *ngIf="uploadKmlFileName">
            <p>{{ uploadKmlFileName }}</p>
          </ng-container>
        </div>
      </ng-container>
    </mat-radio-group>

    <input
      #kmlFileUpload
      accept=".kml,.kmz"
      id="kmlFileUpload"
      name="kmlFileUpload"
      style="display: none"
      type="file" />

    <div class="step-button-container">
      <button (click)="goBack()" color="primary" mat-stroked-button>Back</button>
      <button
        (click)="goNext()"
        [disabled]="!newSiteForm.valid"
        color="primary"
        data-cy="next3-button"
        mat-raised-button
        type="button">
        Next
      </button>
    </div>
  </div>
</form>
